import React, { Component } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { history } from './helpers';
import { PrivateRoute } from './components';
import { ExceptionComponent } from '@app/components';
import LoginPage from './pages/login/login.page';
import ResetPassword from './pages/login/resetPassword.page';
import MainPage from './pages/main/main.page';
import TestMfa from './pages/testMfa/testMfa.page';
import GettingStartedPage from './pages/gettingStarted/gettingStarted.page';
import AuthAgentsPage from './pages/authManager/agents.page';
import AgentDetailsPage from './pages/authManager/details/agentDetails.page';
import ScheduledJobsDetailsPage from './pages/systemManager/details/scheduledJobDetails.page';
import TenantDetailsPage from './pages/systemManager/details/tenantDetails.page';
import LogsPage from './pages/authManager/logs.page';
import ApiExplorer from './pages/authManager/apiExplorer.page';
import AuthenticationPage from './pages/policyManager/policiesAuth.page';
import AuthenticationDetailsPage from './pages/policyManager/details/policyAuthDetails.page';
import ProvisioningPoliciesPage from './pages/policyManager/provisioningPolicies.page';
import AppLibraryPage from './pages/ssoManager/appLibrary.page';
import AppLibraryDetailsPage from './pages/ssoManager/details/appLibraryDetails.page';
import WorkflowRequestsPage from './pages/ssoManager/workflowRequests.page';
import SystemCatalogPage from './pages/ssoManager/systemCatalog.page';
import LaunchPadPage from './pages/launchPad/launchPad.page';
import PasswordVaultsPage from './pages/password/passwordVaults.page';
import VaultManagerPage from './pages/password/vaultManager.page';
import VaultManagerPage2 from './pages/passwordManager/vaultManager.page';
import PasswordRemindersPage from './pages/password/passwordReminders.page';
import PasswordPolicyPage from './pages/password/passwordPolicy.page';
import PasswordPolicyPage2 from './pages/passwordManager/passwordPolicy.page';
import AgentsPage from './pages/password/passwordAgents.page';
import MigrateOnPremPage from './pages/password/migrateOnPrem.page';
import JitUsersPage from './pages/jit/jitUsers.page';
import TenantsPage from './pages/systemManager/tenants.page';
import ScheduledJobsPage from './pages/systemManager/scheduledJobs.page';
import NotificationsPage from './pages/systemManager/notifications.page';
import UsersPage from './pages/directoryManager/users.page';
import GroupsPage from './pages/directoryManager/groups.page';
import RolesPage from './pages/directoryManager/roles.page';
import OrganizationsPage from './pages/directoryManager/organizations.page';
import SyncPage from './pages/directoryManager/sync.page';
import LicenseAllocationPage from './pages/licenseManager/licenseAllocation.page';
import LicenseExpiredPage from './pages/licenseManager/licenseExpired.page';
import HelpPage from './pages/help/help.page';
import ProfilePage from './pages/profile/profile.page';
import AllNotificationsPage from './pages/profile/allNotifications.page';
import UserDetailsPage from './pages/directoryManager/details/userDetails.page';
import GroupDetailsPage from './pages/directoryManager/details/groupDetails.page';
import SyncDetailsPage from './pages/directoryManager/details/syncDetails.page';
import PwsAgentDetailsPage from './pages/password/details/agentDetails.page';
import RoleDetailsPage from './pages/directoryManager/details/roleDetails.page';
import OrganizationDetailsPage from './pages/directoryManager/details/organizationDetails.page';
import SyncOnboardingStartPage from './pages/directoryManager/directorySync/syncOnboardingStart.page';
import AgentOnboardingStartPage from './pages/password/agent/agentOnboardingStart.page';
import VaultDetailsPage from './pages/password/details/vaultDetails.page';
import AddEditVaultPasswordPage from './pages/password/forms/addEditVaultPassword.page';
import { handleShellConfig, loadCurrentUser } from '@app/store/actions';
import { ToastContainer } from 'react-toastify';
import NotificationDetailsPage from './pages/profile/details/notificationDetails.page';
import OnboardPage from './pages/login/onboard.page';
import LaunchPage from './pages/trust/launch.page';
import Authorize from './pages/login/authorize';
import AddEditPasswordServerPolicy from './pages/password/forms/addEditPasswordServerPolicy.page';
import VerifyUser2fa from './pages/directoryManager/details/verifyUser2fa.page';
import PasswordImportChoicePage from './pages/password/passwordImportChoice.page';
import ImportPasswordsPage from './pages/password/importPasswords.page';
import SharedPasswordRedirectPage from './pages/password/sharedPasswordRedirect.page';
import ReportsPage from './pages/reports/reports.page';
import InAppVideosPage from '@app/pages/inAppVideos/inAppVideos.page';
import IntegrationManagerPage from '@app/pages/integrationManager/intergationManager.page';
import DarkwebCompromisePage from '@app/pages/integrationManager/darkwebCompromise.page';
import BullphishPage from '@app/pages/integrationManager/bullphish.page';
import KaseyaOnePage from '@app/pages/kaseyaOne/kaseyaOne.page';

interface IAppProps {
    shellConfig: any;
    shellConfigLoading: boolean;
    actions: {
        handleShellConfig: Function;
        loadCurrentUser: Function;
    };
}

class App extends Component<IAppProps> {
    constructor(props: IAppProps) {
        super(props);
        this.props.actions.loadCurrentUser();
        this.props.actions.handleShellConfig();
    }

    render(): JSX.Element {
        if (this.props.shellConfig.authActive === undefined || this.props.shellConfigLoading) {
            return <div />;
        }

        return (
            <div id='app'>
                <ExceptionComponent />
                <ToastContainer />
                <Router history={history}>
                    <Switch>
                        <Route exact path='/signin' component={LoginPage} />
                        <Route exact path='/signin/passwordreset' component={ResetPassword} />
                        <Route exact path='/onboard/:id' component={OnboardPage} />
                        <Route exact path='/onboard' component={OnboardPage} />
                        <Route exact path='/trust/launch' component={LaunchPage} />
                        <Route exact path='/authorize' component={Authorize} />
                        <Route exact path='/sharepwd' component={SharedPasswordRedirectPage} />

                        {/* You only get here if you are authenticated */}
                        <Route exact path='/' render={() => <Redirect to='/apps' />} />
                        <PrivateRoute exact path='/apps' layout={MainPage} component={LaunchPadPage} />
                        <PrivateRoute exact path='/passwords' layout={MainPage} component={PasswordVaultsPage} />
                        <PrivateRoute exact path='/passwords/details/:id' layout={MainPage} component={VaultDetailsPage} />
                        <PrivateRoute exact path='/system/tenants' layout={MainPage} component={TenantsPage} />
                        <PrivateRoute exact path='/system/jobs' layout={MainPage} component={ScheduledJobsPage} />
                        <PrivateRoute exact path='/system/notifications' layout={MainPage} component={NotificationsPage} />
                        <PrivateRoute exact path='/system/jobs/details/:id' layout={MainPage} component={ScheduledJobsDetailsPage} />
                        <PrivateRoute exact path='/system/tenants/details/:id' layout={MainPage} component={TenantDetailsPage} />
                        <PrivateRoute path='/getting-started' layout={MainPage} component={GettingStartedPage} />
                        <PrivateRoute exact path='/directory/users' layout={MainPage} component={UsersPage} />
                        <PrivateRoute exact path='/directory/groups' layout={MainPage} component={GroupsPage} />
                        <PrivateRoute exact path='/directory/roles' layout={MainPage} component={RolesPage} />
                        <PrivateRoute exact path='/directory/orgs' layout={MainPage} component={OrganizationsPage} />
                        <PrivateRoute exact path='/directory/sync' layout={MainPage} component={SyncPage} />
                        <PrivateRoute path='/passwordserver/passwordreminders' layout={MainPage} component={PasswordRemindersPage} />
                        <PrivateRoute exact path='/passwordserver/vaults' layout={MainPage} component={VaultManagerPage} />
                        <PrivateRoute exact path='/passwordserver/vaults/:id' layout={MainPage} component={VaultDetailsPage} />
                        <PrivateRoute exact path='/passwordserver/vaults/:id/addpassword' layout={MainPage} component={AddEditVaultPasswordPage} />
                        <PrivateRoute
                            exact
                            path='/passwordserver/vaults/:id/editpassword/:passwordId'
                            layout={MainPage}
                            component={AddEditVaultPasswordPage}
                        />
                        <PrivateRoute exact path='/passwordserver/passwordserverpolicy' layout={MainPage} component={PasswordPolicyPage} />
                        <PrivateRoute
                            exact
                            path='/passwordserver/passwordserverpolicy/addpolicy'
                            layout={MainPage}
                            component={AddEditPasswordServerPolicy}
                        />
                        <PrivateRoute
                            exact
                            path='/passwordserver/passwordserverpolicy/editpolicy/:policyId'
                            layout={MainPage}
                            component={AddEditPasswordServerPolicy}
                        />
                        <PrivateRoute exact path='/passwordserver/agents' layout={MainPage} component={AgentsPage} />
                        <PrivateRoute exact path='/passwordserver/import' layout={MainPage} component={PasswordImportChoicePage} />
                        <PrivateRoute exact path='/passwordserver/import/onprem-migrator' layout={MainPage} component={MigrateOnPremPage} />
                        <PrivateRoute exact path='/passwordserver/import/password-import' layout={MainPage} component={ImportPasswordsPage} />
                        <PrivateRoute exact path='/passwordserver/agents/onboarding' layout={MainPage} component={AgentOnboardingStartPage} />
                        <PrivateRoute exact path='/passwordserver/agents/details/:id' layout={MainPage} component={PwsAgentDetailsPage} />

                        {/* PM 2.0*/}
                        <PrivateRoute exact path='/password-manager/vaults' layout={MainPage} component={VaultManagerPage2} />
                        <PrivateRoute exact path='/password-manager/password-policies' layout={MainPage} component={PasswordPolicyPage2} />

                        <PrivateRoute path='/jit/jitters' layout={MainPage} component={JitUsersPage} />
                        <PrivateRoute exact path='/auth/agents' layout={MainPage} component={AuthAgentsPage} />
                        <PrivateRoute path='/auth/logs' layout={MainPage} component={LogsPage} />
                        <PrivateRoute path='/auth/api-explorer' layout={MainPage} component={ApiExplorer} />
                        <PrivateRoute exact path='/integrations' layout={MainPage} component={IntegrationManagerPage} />
                        <PrivateRoute exact path='/integrations/darkweb' layout={MainPage} component={DarkwebCompromisePage} />
                        <PrivateRoute exact path='/integrations/bullphish' layout={MainPage} component={BullphishPage} />
                        <PrivateRoute exact path='/policies/auth' layout={MainPage} component={AuthenticationPage} />
                        <PrivateRoute exact path='/policies/auth/details/:id' layout={MainPage} component={AuthenticationDetailsPage} />
                        <PrivateRoute exact path='/policies/provisioning' layout={MainPage} component={ProvisioningPoliciesPage} />
                        <PrivateRoute exact path='/sso/library' layout={MainPage} component={AppLibraryPage} />
                        <PrivateRoute exact path='/sso/library/details/:id' layout={MainPage} component={AppLibraryDetailsPage} />
                        <PrivateRoute exact path='/sso/requests' layout={MainPage} component={WorkflowRequestsPage} />
                        <PrivateRoute exact path='/sso/syscatalog' layout={MainPage} component={SystemCatalogPage} />
                        <PrivateRoute exact path='/license/allocation' layout={MainPage} component={LicenseAllocationPage} />
                        <PrivateRoute exact path='/license/billing' layout={MainPage} component={LicenseExpiredPage} />
                        <PrivateRoute exact path='/apps/help' layout={MainPage} component={HelpPage} />
                        <PrivateRoute exact path='/profile' layout={MainPage} component={ProfilePage} />
                        <PrivateRoute exact path='/auth/agents/details/:id' layout={MainPage} component={AgentDetailsPage} />
                        <PrivateRoute exact path='/profile/testmfa' layout={MainPage} component={TestMfa} />
                        <PrivateRoute exact path='/directory/users/details/:id' layout={MainPage} component={UserDetailsPage} />
                        <PrivateRoute exact path='/directory/users/details/:id/verifyuser' layout={MainPage} component={VerifyUser2fa} />
                        <PrivateRoute exact path='/directory/groups/details/:id' layout={MainPage} component={GroupDetailsPage} />
                        <PrivateRoute exact path='/directory/sync/details/:id' layout={MainPage} component={SyncDetailsPage} />
                        <PrivateRoute exact path='/directory/roles/details/:id' layout={MainPage} component={RoleDetailsPage} />
                        <PrivateRoute exact path='/directory/orgs/details/:id' layout={MainPage} component={OrganizationDetailsPage} />
                        <PrivateRoute exact path='/directory/sync/onboarding' layout={MainPage} component={SyncOnboardingStartPage} />
                        <PrivateRoute exact path='/profile/read-messages' layout={MainPage} component={AllNotificationsPage} />
                        <PrivateRoute exact path='/profile/read-messages/details/:id' layout={MainPage} component={NotificationDetailsPage} />
                        <PrivateRoute exact path='/kaseyaone' layout={MainPage} component={KaseyaOnePage} />
                        <PrivateRoute exact path='/apps/videos' layout={MainPage} component={InAppVideosPage} />
                        <PrivateRoute exact path='/reporting/password-server' layout={MainPage} component={ReportsPage} />
                        <Route render={() => <Redirect to='/apps' />} />
                    </Switch>
                </Router>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    actions: bindActionCreators(
        {
            loadCurrentUser,
            handleShellConfig
        },
        dispatch
    )
});

const mapStateToProps = (state: any) => {
    return {
        shellConfig: state.basic.shellConfig,
        shellConfigLoading: state.basic.shellConfigLoading
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
